import React from "react";
import { Link } from "react-router-dom";

import Icon from "../../../common/components/Icon";
import user_icon from "../../../assets/icons/user.svg";

function AgroTradeHeader() {
    return (
        <header className="bg-white sticky top-0 w-full z-[90] h-[72px] shadow-sm">
            <div className="max-w-[1200px] mx-auto h-full flex items-center justify-between px-4 lg:px-0">
                <div className="flex items-center gap-4">
                    <Link
                        to="/landing"
                        className="px-5 py-2 rounded-md bg-[#0B5F18] text-white text-sm font-semibold hover:bg-[#094a12] transition"
                    >
                        AGROX
                    </Link>
                    <Link
                        to="/trade"
                        className="px-5 py-2 rounded-md bg-[#7AB30E] text-white text-sm font-semibold hover:bg-[#65970c] transition"
                    >
                        AGROTRADE
                    </Link>

                    <nav className="hidden md:flex items-center gap-4 ml-4 text-sm text-[#374151]">
                        <Link to="/trade#rubrics" className="hover:text-[#147F26]">
                            Рубрики
                        </Link>
                        <Link to="/trade/services" className="hover:text-[#147F26]">
                            Сервисы
                        </Link>
                        <Link to="/trade/gov" className="hover:text-[#147F26]">
                            Гос.органы
                        </Link>
                        <a href="/trade#news" className="hover:text-[#147F26]">
                            Новости
                        </a>
                    </nav>

                    <button className="md:hidden ml-2 flex items-center justify-center h-9 w-9 rounded-full border border-[#e5e7eb] hover:bg-gray-50 transition">
                        <Icon src="bar" alt="menu" className="w-4 h-4" />
                    </button>
                </div>

                <div className="flex items-center gap-3">
                    <button className="hidden md:flex items-center gap-2 text-sm text-[#374151]">
                        <Icon src="glob" alt="language" className="w-4 h-4" />
                        <span>Русский</span>
                    </button>

                    <button className="flex items-center justify-center h-9 w-9 rounded-full border border-[#e5e7eb] hover:bg-gray-50 transition">
                        <Icon src="search" alt="search" className="w-4 h-4" />
                    </button>

                    <button className="flex items-center justify-center h-9 w-9 rounded-full bg-[#0B5F18] hover:bg-[#094a12] transition">
                        <img src={user_icon} alt="user_icon" className="w-4 h-4 invert" />
                    </button>
                </div>
            </div>
        </header>
    );
}

export default AgroTradeHeader;

